// extracted by mini-css-extract-plugin
export default {"wrapper":"_1DrieJlUqckF-ga9nnSv5f","list":"NaohKNVLPhc3S6Vj92jZE","content":"_2FKBGOWixN09YFZGHeIqHn"};